

















// import React, { useState, useCallback, useEffect } from 'react';
// import { CgMore } from 'react-icons/cg';
// import { useNavigate } from 'react-router-dom';
// import MessageModal from '../Modals/Mesage';
// import axios from 'axios';

// const GeneralTable = ({ currentList, handleNavigation, data }) => {
//   const [viewMoreStates, setViewMoreStates] = useState({});
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [currentApplicant, setCurrentApplicant] = useState('');
//   const [jobSeekerModalOpen, setJobSeekerModalOpen] = useState(false);
//   const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);
//   const [distances, setDistances] = useState({});
//   const navigate = useNavigate();
//   const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; // Ensure this is set in your .env file

//   const handleViewToggle = useCallback((index) => {
//     setViewMoreStates(prev => ({
//       ...prev,
//       [index]: !prev[index]
//     }));
//   }, []);

//   const handleModal = useCallback(() => {
//     setModalIsOpen(prev => !prev);
//   }, []);

//   const selectApplicant = useCallback((applicantName) => {
//     setCurrentApplicant(applicantName);
//     handleModal();
//   }, [handleModal]);

//   const handleView = useCallback((jobId) => {
//     navigate(`/${jobId}/applicantResponse`);
//   }, [navigate]);

//   const calculateDistance = useCallback(async (originLGA, destinationLGA) => {
//     if (!GOOGLE_API_KEY || !originLGA || !destinationLGA) return 'N/A';

//     try {
//       const response = await axios.get(
//         `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${encodeURIComponent(originLGA)}&destinations=${encodeURIComponent(destinationLGA)}&mode=driving&units=metric&key=${GOOGLE_API_KEY}`
//       );

//       const data = response.data;
//       if (data.status === 'OK' && data.rows[0].elements[0].status === 'OK') {
//         return data.rows[0].elements[0].distance.text;
//       } else {
//         console.warn('Distance Matrix API warning:', data.status, data.rows[0].elements[0].status);
//         return 'Distance unavailable';
//       }
//     } catch (error) {
//       console.error('Distance calculation error:', error);
//       return 'Error calculating distance';
//     }
//   }, [GOOGLE_API_KEY]);

//   useEffect(() => {
//     const fetchDistances = async () => {
//       const newDistances = {};
//       for (const [index, eachData] of currentList.entries()) {
//         const jobSeekerLGA = eachData.applicant[0].localGovernment || 'Unknown';
//         const jobLGA = eachData.job.localGovernment || 'Unknown';
//         const distance = await calculateDistance(jobSeekerLGA, jobLGA);
//         newDistances[index] = distance;
//       }
//       setDistances(newDistances);
//     };

//     if (currentList.length > 0 && GOOGLE_API_KEY) {
//       fetchDistances();
//     }
//   }, [currentList, calculateDistance, GOOGLE_API_KEY]);

//   const openJobSeekerModal = useCallback((applicant) => {
//     setSelectedJobSeeker(applicant[0]);
//     setJobSeekerModalOpen(true);
//   }, []);

//   const handleViewGuarantor = useCallback(() => {
//     if (selectedJobSeeker?._id) {
//       navigate(`/guarantor-view/${selectedJobSeeker._id}`);
//     } else {
//       console.error('No job seeker ID available for guarantor view');
//     }
//   }, [selectedJobSeeker, navigate]);

//   return (
//     <div className="mt-6 w-full">
//       <div className="overflow-x-auto pb-20">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 S/N
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Name
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Description
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Date Applied
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Time Applied
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Travel Range
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Distance
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Review
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Remark
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {currentList.map((eachData, index) => {
//               const jobSeekerLGA = eachData.applicant[0].localGovernment || 'Unknown';
//               const jobLGA = eachData.job.localGovernment || 'Unknown';
//               const travelRange = `${jobSeekerLGA}-${jobLGA}`;
//               const distance = distances[index] || 'Calculating...';

//               return (
//                 <tr 
//                   key={index} 
//                   className="hover:bg-gray-50 transition-colors duration-200"
//                 >
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                     {index + 1}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium cursor-pointer"
//                       onClick={() => openJobSeekerModal(eachData.applicant)}>
//                     {`${eachData.applicant[0].firstName} ${eachData.applicant[0].lastName}`}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                     {eachData.job.jobTitle}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                     {new Date(eachData.createdAt).toLocaleDateString()}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                     {new Date(eachData.createdAt).toLocaleTimeString([], { 
//                       hour: '2-digit', 
//                       minute: '2-digit' 
//                     })}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                     {travelRange}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                     {/* {distance} */}
//                     60km
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                     {eachData.availability}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
//                       eachData.status === 'Rejected' ? 'bg-red-100 text-red-800' :
//                       eachData.status === 'Shortlisted' ? 'bg-yellow-100 text-yellow-800' :
//                       eachData.status === 'Hired' ? 'bg-green-100 text-green-800' :
//                       'bg-blue-100 text-blue-800'
//                     }`}>
//                       {eachData.status}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 relative z-20">
//                     <div className="relative z-20 inline-block text-left">
//                       <button
//                         onClick={() => handleViewToggle(index)}
//                         className="text-blue-600 hover:text-blue-800 transition-colors duration-200 focus:outline-none"
//                         title="More actions"
//                       >
//                         <CgMore className="w-5 h-5" />
//                       </button>
//                       {viewMoreStates[index] && (
//                         <div className="absolute right-0 mt-2 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-40">
//                           <div className="py-1">
//                             <button
//                               onClick={() => selectApplicant(`${eachData.applicant[0].firstName} ${eachData.applicant[0].lastName}`)}
//                               className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
//                             >
//                               Message
//                             </button>
//                             <button
//                               onClick={() => handleView(eachData.job._id)}
//                               className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
//                             >
//                               View
//                             </button>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//       {modalIsOpen && (
//         <MessageModal 
//           toggle={handleModal} 
//           ApplicantName={currentApplicant} 
//         />
//       )}
//       {jobSeekerModalOpen && selectedJobSeeker && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//             <h2 className="text-xl font-bold mb-4">Job Seeker Details</h2>
//             <div className="space-y-2">
//               <p><strong>First Name:</strong> {selectedJobSeeker.firstName}</p>
//               <p><strong>Last Name:</strong> {selectedJobSeeker.lastName}</p>
//               <p><strong>Email:</strong> {selectedJobSeeker.email}</p>
//               <p><strong>Phone Number:</strong> {selectedJobSeeker.phoneNumber}</p>
//               <p><strong>Whatsapp Number:</strong> {selectedJobSeeker.whatsappNumber || 'N/A'}</p>
//               <p><strong>Location:</strong> {selectedJobSeeker.localGovernment}</p>
//               <p><strong>Address:</strong> {selectedJobSeeker.address}</p>
//               <p><strong>Gender:</strong> {selectedJobSeeker.gender}</p>
//               <p><strong>Marital Status:</strong> {selectedJobSeeker.maritalStatus}</p>
//               <p><strong>Education Level:</strong> {selectedJobSeeker.educationLevel}</p>
//               <p><strong>Date of Birth:</strong> {selectedJobSeeker.dateOfBirth}</p>
//             </div>
//             <div className="mt-4 flex space-x-4">
//               <button
//                 onClick={() => setJobSeekerModalOpen(false)}
//                 className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
//               >
//                 Close
//               </button>
//               <button
//                 onClick={handleViewGuarantor}
//                 className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
//               >
//                 View Guarantor
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default React.memo(GeneralTable);
















import React, { useState, useCallback, useEffect } from 'react';
import { CgMore } from 'react-icons/cg';
import { BiHistory } from 'react-icons/bi'; // ← added for history icon
import { useNavigate } from 'react-router-dom';
import MessageModal from '../Modals/Mesage';
import axios from 'axios';

const GeneralTable = ({
  currentList,
  handleNavigation,
  data,
  onInvite,     // ← NEW: from ApplicantList - opens invitation modal
  onHistory,    // ← NEW: from ApplicantList - opens history modal
}) => {
  const [viewMoreStates, setViewMoreStates] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentApplicant, setCurrentApplicant] = useState('');
  const [jobSeekerModalOpen, setJobSeekerModalOpen] = useState(false);
  const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);
  const [distances, setDistances] = useState({});

  const navigate = useNavigate();
  const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const handleViewToggle = useCallback((index) => {
    setViewMoreStates(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  }, []);

  const handleModal = useCallback(() => {
    setModalIsOpen(prev => !prev);
  }, []);

  const selectApplicant = useCallback((applicantName) => {
    setCurrentApplicant(applicantName);
    handleModal();
  }, [handleModal]);

  const handleView = useCallback((jobId) => {
    navigate(`/${jobId}/applicantResponse`);
  }, [navigate]);

  const calculateDistance = useCallback(async (originLGA, destinationLGA) => {
    if (!GOOGLE_API_KEY || !originLGA || !destinationLGA) return 'N/A';

    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${encodeURIComponent(originLGA)}&destinations=${encodeURIComponent(destinationLGA)}&mode=driving&units=metric&key=${GOOGLE_API_KEY}`
      );

      const data = response.data;
      if (data.status === 'OK' && data.rows[0].elements[0].status === 'OK') {
        return data.rows[0].elements[0].distance.text;
      } else {
        return 'Distance unavailable';
      }
    } catch (error) {
      console.error('Distance calculation error:', error);
      return 'Error calculating distance';
    }
  }, [GOOGLE_API_KEY]);

  useEffect(() => {
    const fetchDistances = async () => {
      const newDistances = {};
      for (const [index, eachData] of currentList.entries()) {
        const jobSeekerLGA = eachData.applicant?.[0]?.localGovernment || 'Unknown';
        const jobLGA = eachData.job?.localGovernment || 'Unknown';
        const distance = await calculateDistance(jobSeekerLGA, jobLGA);
        newDistances[index] = distance;
      }
      setDistances(newDistances);
    };

    if (currentList.length > 0 && GOOGLE_API_KEY) {
      fetchDistances();
    }
  }, [currentList, calculateDistance, GOOGLE_API_KEY]);

  const openJobSeekerModal = useCallback((applicantArray) => {
    setSelectedJobSeeker(applicantArray?.[0] || null);
    setJobSeekerModalOpen(true);
  }, []);

  const handleViewGuarantor = useCallback(() => {
    if (selectedJobSeeker?._id) {
      navigate(`/guarantor-view/${selectedJobSeeker._id}`);
    } else {
      console.error('No job seeker ID available for guarantor view');
    }
  }, [selectedJobSeeker, navigate]);

  return (
    <div className="mt-6 w-full">
      <div className="overflow-x-auto pb-20">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                S/N
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Date Applied
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Time Applied
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Travel Range
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Distance
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Review
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Remark
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentList.map((eachData, index) => {
              const seeker = eachData.applicant?.[0] || {};
              const name = `${seeker.firstName || ''} ${seeker.lastName || ''}`.trim() || '—';
              const jobTitle = eachData.job?.jobTitle || eachData.position || '—';
              const distance = distances[index] || 'Calculating...';

              return (
                <tr 
                  key={eachData._id || index} 
                  className="hover:bg-gray-50 transition-colors duration-200"
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {index + 1}
                  </td>
                  <td 
                    className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium cursor-pointer"
                    onClick={() => openJobSeekerModal(eachData.applicant)}
                  >
                    {name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {jobTitle}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {new Date(eachData.createdAt).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {new Date(eachData.createdAt).toLocaleTimeString([], { 
                      hour: '2-digit', 
                      minute: '2-digit' 
                    })}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {seeker.localGovernment || '—'} - {eachData.job?.localGovernment || '—'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {distance}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {eachData.availability || '—'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      eachData.status === 'Rejected' ? 'bg-red-100 text-red-800' :
                      eachData.status === 'Shortlisted' ? 'bg-yellow-100 text-yellow-800' :
                      eachData.status === 'Hired' ? 'bg-green-100 text-green-800' :
                      eachData.status === 'Scheduled' ? 'bg-purple-100 text-purple-800' :
                      'bg-blue-100 text-blue-800'
                    }`}>
                      {eachData.status || 'Applied'}
                    </span>
                  </td>

                  {/* ACTIONS COLUMN - Here are your new buttons */}
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    <div className="flex items-center gap-4 justify-end">

                      {/* 1. Invitation Button (status-dependent) */}
                      {eachData.status === 'Applied' && (
                        <button
                          onClick={() => onInvite?.(eachData, 'shortlist')}
                          className="text-blue-600 hover:text-blue-800 font-medium text-sm"
                          title="Shortlist & Send Invitation"
                        >
                          Shortlist
                        </button>
                      )}

                      {eachData.status === 'Shortlisted' && (
                        <button
                          onClick={() => onInvite?.(eachData, 'interview')}
                          className="text-green-600 hover:text-green-800 font-medium text-sm"
                          title="Schedule Interview"
                        >
                          Interview
                        </button>
                      )}

                      {eachData.status === 'Scheduled' && (
                        <button
                          onClick={() => onInvite?.(eachData, 'offer')}
                          className="text-purple-600 hover:text-purple-800 font-medium text-sm"
                          title="Send Job Offer"
                        >
                          Offer
                        </button>
                      )}

                      {/* 2. History Button */}
                      <button
                        onClick={() => onHistory?.(eachData)}
                        className="text-gray-600 hover:text-gray-900 p-1 rounded hover:bg-gray-100 transition-colors"
                        title="View invitation history"
                      >
                        <BiHistory className="w-5 h-5" />
                      </button>

                      {/* 3. Existing More Actions */}
                      <div className="relative inline-block text-left">
                        <button
                          onClick={() => handleViewToggle(index)}
                          className="text-blue-600 hover:text-blue-800 transition-colors duration-200 focus:outline-none"
                          title="More actions"
                        >
                          <CgMore className="w-5 h-5" />
                        </button>

                        {viewMoreStates[index] && (
                          <div className="absolute right-0 mt-2 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-40">
                            <div className="py-1">
                              <button
                                onClick={() => selectApplicant(name)}
                                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                              >
                                Message
                              </button>
                              <button
                                onClick={() => handleView(eachData.job?._id)}
                                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                              >
                                View
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {modalIsOpen && (
        <MessageModal 
          toggle={handleModal} 
          ApplicantName={currentApplicant} 
        />
      )}

      {jobSeekerModalOpen && selectedJobSeeker && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Job Seeker Details</h2>
            <div className="space-y-2">
              <p><strong>First Name:</strong> {selectedJobSeeker.firstName || '—'}</p>
              <p><strong>Last Name:</strong> {selectedJobSeeker.lastName || '—'}</p>
              <p><strong>Email:</strong> {selectedJobSeeker.email || '—'}</p>
              <p><strong>Phone Number:</strong> {selectedJobSeeker.phoneNumber || '—'}</p>
              <p><strong>Whatsapp Number:</strong> {selectedJobSeeker.whatsappNumber || 'N/A'}</p>
              <p><strong>Location:</strong> {selectedJobSeeker.localGovernment || '—'}</p>
              <p><strong>Address:</strong> {selectedJobSeeker.address || '—'}</p>
              <p><strong>Gender:</strong> {selectedJobSeeker.gender || '—'}</p>
              <p><strong>Marital Status:</strong> {selectedJobSeeker.maritalStatus || '—'}</p>
              <p><strong>Education Level:</strong> {selectedJobSeeker.educationLevel || '—'}</p>
              <p><strong>Date of Birth:</strong> {selectedJobSeeker.dateOfBirth || '—'}</p>
            </div>
            <div className="mt-4 flex space-x-4">
              <button
                onClick={() => setJobSeekerModalOpen(false)}
                className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
              >
                Close
              </button>
              <button
                onClick={handleViewGuarantor}
                className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
              >
                View Guarantor
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(GeneralTable);